<p-toast [style]="{ marginTop: '80px' }"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="msgTemplates" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="msgTemplateId"
  selectionMode="single" [(selection)]="msgTemplate" (onRowSelect)="onRowSelect($event)" [loading]="loading"
  [paginator]="showPagination" [rows]="25" [rowsPerPageOptions]="[25, 100, 200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{ width: 'auto' }"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px">Msg Templates</h1>

      <!-- Global Search Input -->
      <span style="float: left; margin-bottom: 10px;">
        <input pInputText type="text" placeholder="Search and Press Enter..." [(ngModel)]="globalSearchValue"
          (keydown.enter)="onGlobalSearch()" (input)="onInputChange()" style="width: 200px; margin-left: 10px;" />
      </span>

      <span>
        <!--clear filters-->
        @if (showFilter) {
<button pButton pRipple class="p-button-text" style="
            font-size: 80%;
            padding: 0.643rem 0.75rem !important;
            margin-right: 10px;
          " (click)="reloadPage()">
            Clear Filters
          </button>
        }

        <!--add new-->
        @if (!outlineNewButton) {
          <button pButton pRipple class="p-button-outlined"
            style="padding: 0.643rem 0.75rem !important" (click)="onOpenFormAdd()">
            New MsgTemplate +
          </button>
        }
        <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important" (click)="onOpenFormAdd()">
          New MsgTemplate +
        </button>

        <button pButton pRipple type="button" class="p-button-success ms-2" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          [icon]="exportToExcelLoading ? 'pi pi-spin pi-spinner' : 'pi pi-file-excel'"
          [label]="exportToExcelLoading ? 'Exporting...' : 'Export to Excel'"
          (click)="exportToExcel()"
          [disabled]="exportToExcelLoading">
        </button>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{ width: col.width }">
          {{ col.header }}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{ width: 'auto' }"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'10px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'msgTemplateId', 'in')" style="width:100px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'10px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'letterHeadTemplate.msgTemplateId', 'in')" style="width:100px;"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text"
        (input)="pt.filter($event.target.value, 'name', 'in')" style="width:100px;"></th>
        <th><p-dropdown #aa [options]="statusesForFilter" appendTo="body"
          (onChange)="pt.filter($event.value, 'status', 'in')" [style]="{'width':'50px','min-width':'100%'}"
          styleClass="p-column-filter" placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
          <ng-template let-option pTemplate="item">
            <span>{{option.name}}</span>
          </ng-template>
        </p-dropdown>
      </th>
      <th [ngStyle]="{'width': 'auto'}">
        <p-multiSelect class="multiselectdropdown" [options]="msgAudiences" displaySelectedLabel optionLabel="name"
          optionValue="value" appendTo="body" (onChange)="pt.filter($event.value, 'msgAudience', 'in');"
        optionLabel="name" display="chip" [displaySelectedLabel]="true"></p-multiSelect>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'subject', 'in')" style="width:100px;"></th>
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailHtml', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailText', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'30px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobileText', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'senderName', 'in')" style="width:100px;"></th> -->
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'senderEmail', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'80px','min-width':'100%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'senderMobileNum', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': '10px'}"><input [ngStyle]="{'width':'10px','min-width':'100%'}" pInputText type="text"
      (input)="pt.filter($event.target.value, 'senderCountryCode', 'in')" style="width:100px;"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-msgTemplate>
  <tr [pSelectableRow]="msgTemplate">
    <td>{{ msgTemplate.msgTemplateId }}</td>
    <td>{{ msgTemplate.letterHeadTemplateId }}</td>
    <td style="max-width : 250px !important;">{{ msgTemplate.name }}</td>
    <td>{{ getStatusName(msgTemplate) }}</td>
    <td>{{ getMsgAudienceName(msgTemplate) }}</td>
    <td style="max-width : 250px !important;">{{ msgTemplate.subject }}</td>
    <!-- <td style="max-width : 400px !important;">{{ msgTemplate.emailHtml }}</td>
    <td style="max-width : 300px !important;">{{ msgTemplate.emailText }}</td>
    <td style="max-width : 300px !important;">{{ msgTemplate.mobileText }}</td>
    <td>{{ msgTemplate.senderName }}</td> -->
    <td>{{ msgTemplate.senderEmail }}</td>
    <td>{{ msgTemplate.senderMobileNum }}</td>
    <td>{{ msgTemplate.senderCountryCode }}</td>
    <td>
      <span style="float: none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true" style="color: blue; font-size: 110%; padding-right: 20px"
          (click)="onOpenFormEdit(msgTemplate)"></i>
        </a>
      </span>
    </td>
  </tr>
</ng-template>
</p-table>